import React from 'react'

// Shown when a render error bubbles up to the top-level Sentry ErrorBoundary.
// The error has already been reported to Sentry by the time this renders.
export default function ErrorFallback ({ resetError }) {
  return (
    <div className='flex flex-col items-center justify-center min-h-screen p-6 text-center gap-4'>
      <h1 className='text-2xl font-bold'>Something went wrong</h1>
      <p className='max-w-md'>
        The game hit an unexpected error and this has been reported. Try
        reloading to pick up where you left off.
      </p>
      <button
        className='px-4 py-2 border rounded'
        onClick={() => {
          resetError()
          window.location.reload()
        }}
      >
        Reload
      </button>
    </div>
  )
}
